module.exports = __webpack_public_path__ + "static/media/Ribbon-01.acbd3ab9.svg";